<template>
  <div>
    <q-dialog v-model="valueLocal" persistent>
      <q-card class="card-authorization">
        <q-card-section class="header">
          <div class="text-h6 text-center">
            <q-icon name="o_delete" style="color: #002f6c; font-size: 50px" />
          </div>
        </q-card-section>
        <q-card-section class="header">
          <div class="text-h6" id="title-card-authorization">
            No puede eliminar la acción porque está asociada a otro indicador.
          </div>
        </q-card-section>
        <q-card-actions align="center" class="text-primary container-actions">
          <q-btn
            color="primary"
            padding="xs lg"
            label="Aceptar"
            v-close-popup
            @click="cancel()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { QDialog } from 'quasar';
export default {
  components: {
    QDialog
  },
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      valueLocal: this.value
    };
  },
  created () {
  },
  watch: {
    value: {
      handler: function () {
        this.valueLocal = this.value;
        this.$emit('input', this.valueLocal);
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.card-authorization {
  min-width: 700px;
   .header {
    padding-top: 18px;
    #title-card-authorization {
      padding: 11px 20px 30px 20px;
      font-family: 'DINPro-Bold';
      font-size: 22px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #4d4d4d;
    }
  }
  .container-actions {
    padding-top: 15px;
  }
  &::v-deep {
    .q-field--standard .q-field__control:before {
      border-bottom-color: rgba(89, 89, 89, 0.5) !important;
    }
  }
}
.q-dialog__inner {
  div::v-deep {
    border-radius: 12px !important;
  }
}
.q-card {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
